import { FormattedMessage } from "react-intl";
import NewBuildingIcon from "nvent-web/assets/svg/building-new.svg";
import OldBuildingIcon from "nvent-web/assets/svg/building-old.svg";
import RenovatedBuildingIcon from "nvent-web/assets/svg/building-renovated.svg";
import { type ProjectInsulationItem } from "nvent-web/types/ProjectInsulationItem";

export const PROJECT_INSULATION_ITEMS: ProjectInsulationItem[] = [
  {
    buildingType: "passive_building",
    icon: <img src={NewBuildingIcon} />,
    title: <FormattedMessage id="selectionGuide.newBuilding" />,
    description: (
      <FormattedMessage id="selectionGuide.newBuilding.insulation" />
    ),
  },
  {
    buildingType: "new_building",
    icon: <img src={RenovatedBuildingIcon} />,
    title: <FormattedMessage id="selectionGuide.renovatedBuilding" />,
    description: (
      <FormattedMessage id="selectionGuide.renovatedBuilding.insulation" />
    ),
  },
  {
    buildingType: "old_building",
    icon: <img src={OldBuildingIcon} />,
    title: <FormattedMessage id="selectionGuide.oldBuilding" />,
    description: (
      <FormattedMessage id="selectionGuide.oldBuilding.insulation" />
    ),
  },
];
